// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/client/modules/orders/modules/orders-list/components/claims-list/claims-list.less
// module id = 3765
// module chunks = 0